import { Component, Input, OnInit } from '@angular/core';
import { LazyAssetComponent } from '@features/lazy-image/components/lazy-asset/lazy-asset.component';
import { TextBlock } from '@generated/graphql';

import { NgClass } from '@angular/common';
import { AssetImageConfiguration } from '@features/lazy-image/components/lazy-asset-lazy/lazy-asset-lazy.component';

@Component({
    selector: 'app-home-why-followalice-reason-block',
    templateUrl: './home-why-followalice-reason-block.component.html',
    imports: [NgClass, LazyAssetComponent],
})
export class HomeWhyFollowaliceReasonBlockComponent implements OnInit {
    @Input() reason: TextBlock;
    @Input() left = true;
    @Input() last = false;
    @Input() first = false;
    @Input() index = 0;

    imageConfiguration: AssetImageConfiguration;

    constructor() {}

    ngOnInit(): void {
        this.imageConfiguration = {
            image: this.reason?.image,
            ratioWidth: 1,
            ratioHeight: 1,
            width: 500,
        };
    }
}
